import { Injectable, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ExtratoFilter } from './extrato-filter';
import { LancamentoDTO } from './lancamento-dto.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TotalDayDTO } from '../pedido/total-day-dto.model';
import { TransferDTO } from './transfer-dto.model';
import { DepositoPixFilter } from './deposito-pix-filter';
import { DepositoPix } from './deposito-pix.model';

@Injectable({
  providedIn: 'root'
})
export class ExtratoService {

  transferEvent = new EventEmitter();

  constructor(private http: HttpClient) { }

  getLancamentos(extratoFilter: ExtratoFilter): Observable<LancamentoDTO[]> {
    const url = `${environment.apiUrl}/lancamentos`;
    return this.http.get<LancamentoDTO[]>(url, { params: extratoFilter.getSearchParams() });
  }

  getCreditosDia(extratoFilter: ExtratoFilter): Observable<TotalDayDTO[]> {
    const url = `${environment.apiUrl}/lancamentos/group/dia`;
    return this.http.get<TotalDayDTO[]>(url, { params: extratoFilter.getSearchParams() });
  }

  transfer(transferDTO: TransferDTO): Observable<TransferDTO> {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<TransferDTO>(`${environment.apiUrl}/lancamentos/transfer`, transferDTO, { headers });
  }

  // Deposito PIX
  getDepositosPix(depositoPixFilter: DepositoPixFilter): Observable<DepositoPix[]> {
    const url = `${environment.apiUrl}/extratos/depositos/pix`;
    return this.http.get<DepositoPix[]>(url, { params: depositoPixFilter.getSearchParams() });
  }

  // getDepositosPix(depositoPixFilter: DepositoPixFilter): Observable<DepositoPix[]> {
  //   const url = `${environment.apiUrl}/extratos/depositos/pix/${depositoPixFilter.licencaId}`;
  //   return this.http.get<DepositoPix[]>(url);
  // }

  postDepositoPix(depositoPix: DepositoPix): Observable<DepositoPix> {
    console.log('ExtratoService POST: ', depositoPix);
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<DepositoPix>(`${environment.apiUrl}/extratos/depositos/pix`, depositoPix, { headers });
  }

}
